import { Tabs } from "@jhool-io/fe-components";
import { useSearchParams } from "react-router-dom";
import PaymentsHistory from "../../../payments/components/PaymentsHistory/PaymentsHistory";
import OutstandingBills from "../OutstandingBills/OutstandingBills";

export default function BillsWrapper() {
    const [searchParams, setSearchParams] = useSearchParams();

    const handleSetTabInUrl = (tab: string) => {
        searchParams.set("tab", tab);
        setSearchParams(searchParams);
    };

    const tabItems = [
        {
            key: "outstanding_bills",
            label: "Outstanding Bills",
            children: <OutstandingBills />,
            onClick: () => handleSetTabInUrl("outstanding_bills"),
        },
        {
            key: "payments_history",
            label: "Payments History",
            children: <PaymentsHistory />,
            onClick: () => handleSetTabInUrl("payments_history"),
        },
    ];

    return (
        <div className="page">
            <Tabs
                items={tabItems}
                className="mb-36 !w-[100%] !items-end"
                defaultActiveKey={
                    searchParams.get("tab") || "outstanding_bills"
                }
                size="medium"
            />
        </div>
    );
}
